<template>
  <p-dialog :visible.sync="isOpen" header="Trailing Stop" @hide="onClose" :modal="true">
    <div>
      <div class="p-d-flex form-field-drp">

        <div class="form-field" style="width: 50%;">
          <label>Date</label>
          <p-inputText type="date" placeholder="Date" v-model="periodStartDate" />
        </div>
        <div class="form-field" style="width: 50%;">
          <label>Entry price</label>
          <p-inputText type="number" placeholder="Entry Price" step="0.01" min="0" v-model="entryPrice" />
        </div>
      </div>

      <div class="form-field-drp p-d-flex p-ai-end">

        <div class="form-field" style="width: 50%;">
          <label>Trailing Type</label>
          <p-dropdown v-model="selectedTrailingType" :options="trailingType"
            optionLabel="text" optionValue="value" appendTo='body' placeholder="Trailing Type" />
        </div>

        <div class="form-field" v-if="selectedTrailingType === 'step-price'">
          <label>Step Price</label>
          <p-inputText type="number" placeholder="Step Price" step="0.01" min="0" v-model="stepPrice"
            name="stepPrice" />
        </div>

        <div class="form-field" v-if="selectedTrailingType === 'value'">
          <label>$ Risk Value</label>
          <p-inputText type="number" placeholder="Risk Value" name="riskValueInCash" value="500"
            v-model="riskValueInCash" />
        </div>

        <div class="form-field" v-if="selectedTrailingType === '%value'">
          <label>Risk %</label>
          <p-inputText type="number" placeholder="Risk Value %" name="riskValueInPct" value="10"
            v-model="riskValueInPct" />
        </div>

        <div class="form-field" v-if="selectedTrailingType === 'atr'">
          <label>Day Period</label>
          <p-inputText type="number" name="atrPeriod" placeholder="ATR Period" value="10" v-model="atrPeriod" />
        </div>

        <div class="form-field" v-if="selectedTrailingType === 'atr'">
          <h3>and</h3>
        </div>

        <div class="form-field" v-if="selectedTrailingType === 'atr'">
          <label>Multiplier</label>
          <p-inputText type="number" placeholder="Multiplier" name="atrMultiplier" value="5" v-model="atrMultiplier" />
        </div>

      </div>

      <div class="form-field" v-if="
        selectedTrailingType === 'step-price' || selectedTrailingType === 'atr'
      ">
        <label>Stop Price</label>
        <p-inputText type="number" placeholder="Stop Price" step="0.01" min="0" v-model="stopPrice" />

      </div>
    </div>
    <template #footer>
      <p-button label="OK" @click="updateData" />
      <p-button label="Save as Default" class="p-button-info" @click="saveAsDefault" />
      <p-button label="Cancel" class="p-button-secondary" @click="onClose" />
    </template>
  </p-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { chartEvents } from "../../../chartEvents";
import moment from 'moment/moment'
import { saveTrailingStopDefault } from '../../../services/user';
import atr from '../../../overlays/indicators/calculators/atr';
export default {
  name: "TrailingStop",
  components: {
  },
  props: {
    trialingStopData: {
      type: Object,
      default: () => { }
    }
  },
  methods: {
    recalculateAtrStopPrice() {
      if (this.selectedTrailingType !== 'atr') return;
      let period = parseInt(this.atrPeriod) || 14;
      let multiplier = parseFloat(this.atrMultiplier) || 5;
      let entry = parseFloat(this.entryPrice);
      if (!entry || isNaN(entry)) return;

      let atrVal = 0;
      if (this.multiOhlcv && this.multiOhlcv[this.selectedTab]) {
        const ohlcv = this.multiOhlcv[this.selectedTab];
        const mappedData = ohlcv.map(arr => ({
          date: arr[0],
          open: arr[1],
          high: arr[2],
          low: arr[3],
          close: arr[4],
          volume: arr[5]
        }));
        const atrValues = atr(mappedData, period);
        // Try to find ATR value at the drawing's start time
        const startTime = this.$props?.trialingStopData?.p1?.[2]
          || this.$props?.trialingStopData?.startClickTime
          || null;
        if (startTime && atrValues.length > 0) {
          const atrEntry = atrValues.find(x => x[0] === startTime);
          if (atrEntry) {
            atrVal = atrEntry[1];
          }
        }
        // Fallback to last available ATR value
        if (atrVal === 0 && atrValues.length > 0) {
          atrVal = atrValues[atrValues.length - 1][1];
        }
      }
      if (atrVal > 0) {
        this.stopPrice = parseFloat((entry - (atrVal * multiplier)).toFixed(3));
      }
    },
    onClose() {
      this.$emit("hideTrailingStop");
    },
    updateData() {
      let identity = "UpdateTrailingStopSettings" + this.trialingStopData?.$uuid;
      // let identity = "UpdateTrailingStopSettings";
      chartEvents.$emit(identity, {
        stepPrice: this.stepPrice,
        stopPrice: this.stopPrice,
        entryPrice: this.entryPrice,
        uuid: this.trialingStopData?.$uuid,
        trailingType: this.selectedTrailingType,
        atrPeriod: this.atrPeriod,
        atrMultiplier: this.atrMultiplier,
        riskValueInPct: this.riskValueInPct,
        riskValueInCash: this.riskValueInCash,
        periodStartDate: moment(this.periodStartDate).valueOf()

      });
      this.$emit("hideTrailingStop");

    },
    async saveAsDefault() {
      // Placeholder for API call to save default settings
      // You need to implement this API in your backend
      const defaultSettings = {trailingStoptoolSettings:{
        stepPrice: this.stepPrice,
        stopPrice: this.stopPrice,
        entryPrice: this.entryPrice,
        trailingType: this.selectedTrailingType,
        atrPeriod: this.atrPeriod,
        atrMultiplier: this.atrMultiplier,
        riskValueInPct: this.riskValueInPct,
        riskValueInCash: this.riskValueInCash,
        periodStartDate: moment(this.periodStartDate).valueOf()
      }};
      // Example: await saveTrailingStopDefault(defaultSettings)
      const response = await saveTrailingStopDefault(defaultSettings);
      if(response && response.updated){
        this.$store.commit('SET_TRAIL_STOP_TOOLS_DEFAULT_VALUES', defaultSettings.trailingStoptoolSettings);
        let identity = "UpdateTrailingStopSettings" + this.trialingStopData?.$uuid;
        chartEvents.$emit(identity, {
          stepPrice: this.stepPrice,
          stopPrice: this.stopPrice,
          entryPrice: this.entryPrice,
          uuid: this.trialingStopData?.$uuid,
          trailingType: this.selectedTrailingType,
          atrPeriod: this.atrPeriod,
          atrMultiplier: this.atrMultiplier,
          riskValueInPct: this.riskValueInPct,
          riskValueInCash: this.riskValueInCash,
          periodStartDate: moment(this.periodStartDate).valueOf()
        });
        this.$emit("hideTrailingStop");
      }
      
      // Show a notification or feedback to the user
      // this.$toast && this.$toast.add({severity:'success', summary:'Default Saved', detail:'Trailing stop settings saved as default.'});
    },
  },
  data() {
    return {
      isOpen: false,
      entryPrice: 0,
      stopPrice: 0,
      stepPrice: 0,
      trailingType: [
        { text: "ATR", value: "atr" },
        { text: "dollar distance stop loss", value: "value" },
        { text: "% value of a parcel", value: "%value" },
        { text: "based on step price", value: "step-price" },
      ],
      atrPeriod: 14,
      atrMultiplier: 2,
      riskValueInPct: 10,
      riskValueInCash: 200,
      selectedTrailingType: "step-price",
      periodStartDate: moment(new Date()).format('YYYY-MM-DD').toString()
    };
  },
  computed: {
    ...mapGetters(["themeDarkMode", "themeFontColor", "themeSecondaryColor", "themePrimaryColor", "getStopToolsDefaultValues", "multiOhlcv", "selectedTab"]),
  },
  created() {
    if (this.$props?.trialingStopData) {

      let startDate = this.$props?.trialingStopData?.p1?.[2] ? new Date(this.$props.trialingStopData.p1[2]) : this.$props?.trialingStopData?.startClickTime ? new Date(this.$props.trialingStopData.startClickTime) : new Date()
      
      this.periodStartDate = moment(startDate).format('YYYY-MM-DD').toString()

      this.stepPrice = this.$props?.trialingStopData?.stepPrice
      this.entryPrice = this.$props?.trialingStopData?.entryPrice
      this.stopPrice = this.$props?.trialingStopData?.stopPrice
      this.atrPeriod = this.$props?.trialingStopData?.atrPeriod || 14
      this.atrMultiplier = this.$props?.trialingStopData?.atrMultiplier || 2
      this.riskValueInPct = this.$props?.trialingStopData?.riskValueInPct || 7
      this.riskValueInCash = this.$props?.trialingStopData?.riskValueInCash || 7
      this.selectedTrailingType = this.$props?.trialingStopData?.trailingType ? this.$props?.trialingStopData?.trailingType : 'step-price'
    }
  },
  watch: {
    periodStartDate(newVal, oldVal) {

    },
    atrPeriod(newVal, oldVal) {
      if (newVal !== oldVal && this.selectedTrailingType === 'atr') {
        this.recalculateAtrStopPrice();
      }
    },
    atrMultiplier(newVal, oldVal) {
      if (newVal !== oldVal && this.selectedTrailingType === 'atr') {
        this.recalculateAtrStopPrice();
      }
    },
  },
  mounted() {
    if (this.$props?.trialingStopData) {
      this.isOpen = true;
    }
  }
};
</script>

<style></style>
